export const COMPLETED_TEXT = 'Completed'
export const IN_PROGRESS_TEXT = 'In Progress'
export const NOT_STARTED_TEXT = 'Not Started'
